import React from 'react';
import cn from 'classnames';

import Icon from 'components/UI/Icon';
import RadioMark from 'components/UI/RadioMark';
import CheckMark from 'components/UI/CheckMark';

import * as styles from './InputButton.module.scss';

export default function InputButton({
  name,
  type = 'radio',
  className,
  checked,
  icon,
  title,
  theme,
  ...rest
}) {
  return (
    <label
      className={cn(
        styles.inputButton,
        styles[type],
        checked && styles.checked,
        theme && styles[theme],
        className,
      )}
    >
      <input className={styles.input} type={type} name={name} checked={checked} {...rest} />
      {icon && (
        <span className={styles.icon}>
          <Icon name={icon} />
        </span>
      )}
      <span>{name}</span>
      {type === 'radio' ? (
        <RadioMark className={styles.checkmark} checked={checked} size="sm" />
      ) : (
        <CheckMark className={styles.checkmark} checked={checked} size="sm" />
      )}
    </label>
  );
}
